module.exports = __webpack_public_path__ + "img/logo.1f4f2dc9.png";